import { components } from "./components";
import { muiPrimaryFromScale } from "./palette-primary";
import { typography } from "./typography";
import { primary, themeColors } from "./theme-colors";

/** @deprecated Use string ids from site builder only; single code baseline. */
const THEMES = { DEFAULT: "DEFAULT" };

/**
 * Single MUI baseline merged under `layout.theme.mui` from the site builder / DB.
 * Named ids (HAIANH, LUXE, …) resolve to this preset; colors come from layout JSON.
 */
const defaultThemeOptions = {
  typography,
  components,
  palette: {
    primary: muiPrimaryFromScale(primary),
    ...themeColors,
  },
};

const themesOptionList = {
  [THEMES.DEFAULT]: defaultThemeOptions,
};

const themeOptions = (themeName) => {
  return themesOptionList[themeName] ?? themesOptionList[THEMES.DEFAULT];
};

export default themeOptions;
